import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'

@Injectable()
export class ApiEnvironment {
  constructor () {}

  baseUrl (): string {
    return environment.baseApiUrl
  }
}
